module.exports = {"MOBILE_VIEW":false,"SPECIAL_COLOR":"#01B3C8","DEFAULT_STATUSES_TO_SHOW":["100","500","610","700","920","300"],"COLLECTING_STATUSES_TO_SHOW":[],"PACKAGING_STATUSES_TO_SHOW":[],"DISTRIBUTION_STATUSES_TO_SHOW":[],"DEFAULT_ACTIVE_STATUS":33,"COLLECTING_ACTIVE_STATUS":33,"PACKAGING_ACTIVE_STATUS":34,"DISTRIBUTION_ACTIVE_STATUS":37,"HAS_DELIVERY_RANGE":false,"PRINT_PACKAGE_ORDER_LIST":true}


//////////////////
// WEBPACK FOOTER
// ./src/plugins/tfs/platformConfigs/theme/packageOrderList.json
// module id = 550
// module chunks = 1